// Alta del Plan Profesor en CATALÁN (21/10/2026): `signup?plan=profesor&lang=ca`. Mismo patrón que
// sectorDetail.js / profesorAutoescuela.js (textos por idioma en un objeto, sin librería de i18n): la página de
// alta sigue en castellano para todo lo demás; solo el alta de profesor admite `lang=ca`.
// `lang: "ca"` viaja a /public/signup/start y a_publicSignupStart lo guarda (solo con plan profesor): la cuenta
// nace con la app en catalán y los avisos a sus alumnos en catalán (c_autoescuela_config.idioma_mensajes).
// Catalán central («el teu», «aquest»), no valenciano. Ficha: docs/features/autoescuela-plan-profesor.md («Catalán»).

/** "ca" solo con ?plan=profesor&lang=ca (también «ca-ES»); cualquier otra cosa, "es". PURA. */
export function altaLang(search) {
  const q = new URLSearchParams(search || "");
  if (q.get("plan") !== "profesor") return "es";
  return String(q.get("lang") || "").trim().toLowerCase().startsWith("ca") ? "ca" : "es";
}

export const ALTA_TEXT = {
  es: {
    titleProfesor: "Tu agenda de profesor, gratis 15 días",
    subProfesor: "Tus prácticas y los avisos a tus alumnos por WhatsApp · luego 15 €/mes · sin tarjeta",
    dudas: "¿Dudas? Escríbeme por WhatsApp",
    waProfesor: "Hola, soy profesor de autoescuela y tengo una duda sobre ConextCRM.",
    duenoPregunta: "¿La autoescuela es tuya?",
    duenoDemo: "Te la enseñamos en una demo",
    yaTieneCuenta: "Ese usuario ya tiene una cuenta.",
    iniciarSesion: "Iniciar sesión",
    olvide: "He olvidado mi contraseña",
    enlaceCaducado: "El enlace ha caducado. Crea tu cuenta aquí en un par de minutos.",
    tuCuentaPara: "Tu cuenta para",
    codigoAEste: "Te enviaremos el código de 6 dígitos a este WhatsApp",
    password: "Contraseña (mín. 8 caracteres)",
    enviando: "Enviando código...",
    enviar: "Enviar código por WhatsApp",
    otrosDatos: "Prefiero registrarme con otros datos",
    nombreProfesor: "Tu nombre y apellido",
    nombreRequerido: "Escribe tu nombre y apellido.",
    asiTeVeran: "Así te verán tus alumnos en los avisos de WhatsApp.",
    movil: "Tu móvil (WhatsApp)",
    codigoPorWa: "Te enviaremos el código por WhatsApp",
    pediremos: "Te pediremos un código de 6 dígitos para confirmar",
    enviadoA: "Te hemos enviado un código por WhatsApp al",
    tuWhatsapp: "tu WhatsApp",
    verificando: "Verificando...",
    verificar: "Verificar y entrar",
    cambiarDatos: "Cambiar datos",
    noLlega: "¿No te llega?",
    reenviar: "Reenviar por WhatsApp",
    yaTienes: "¿Ya tienes cuenta? ",
    iniciaAqui: "Inicia sesión aquí",
  },
  ca: {
    titleProfesor: "La teva agenda de professor, gratis 15 dies",
    subProfesor: "Les teves pràctiques i els avisos als teus alumnes per WhatsApp · després 15 €/mes · sense targeta",
    dudas: "Dubtes? Escriu-me per WhatsApp",
    waProfesor: "Hola, soc professor d'autoescola i tinc un dubte sobre ConextCRM.",
    duenoPregunta: "L'autoescola és teva?",
    duenoDemo: "Te l'ensenyem en una demo",
    yaTieneCuenta: "Aquest usuari ja té un compte.",
    iniciarSesion: "Iniciar sessió",
    olvide: "He oblidat la contrasenya",
    enlaceCaducado: "L'enllaç ha caducat. Crea el teu compte aquí en un parell de minuts.",
    tuCuentaPara: "El teu compte per a",
    codigoAEste: "T'enviarem el codi de 6 xifres a aquest WhatsApp",
    password: "Contrasenya (mín. 8 caràcters)",
    enviando: "Enviant el codi...",
    enviar: "Enviar el codi per WhatsApp",
    otrosDatos: "Prefereixo registrar-me amb altres dades",
    nombreProfesor: "El teu nom i cognom",
    nombreRequerido: "Escriu el teu nom i cognom.",
    asiTeVeran: "Així et veuran els teus alumnes als avisos de WhatsApp.",
    movil: "El teu mòbil (WhatsApp)",
    codigoPorWa: "T'enviarem el codi per WhatsApp",
    pediremos: "Et demanarem un codi de 6 xifres per confirmar",
    enviadoA: "T'hem enviat un codi per WhatsApp al",
    tuWhatsapp: "el teu WhatsApp",
    verificando: "Verificant...",
    verificar: "Verificar i entrar",
    cambiarDatos: "Canviar les dades",
    noLlega: "No t'arriba?",
    reenviar: "Tornar a enviar per WhatsApp",
    yaTienes: "Ja tens compte? ",
    iniciaAqui: "Inicia sessió aquí",
  },
};

// Errores del backend en catalán (los de castellano siguen en Signup.jsx, ERROR_MESSAGES).
export const ERRORES_CA = {
  business_name_required: "Introdueix el nom del teu negoci.",
  invalid_usuario: "Introdueix el teu mòbil amb WhatsApp (amb el prefix si no és espanyol).",
  weak_password: "La contrasenya ha de tenir com a mínim 8 caràcters.",
  sector_required: "Selecciona el tipus de negoci.",
  usuario_en_uso: "Aquest usuari ja té un compte. Inicia sessió.",
  email_in_use: "Aquest usuari ja té un compte. Inicia sessió.",
  too_many_requests: "Massa intents. Torna-ho a provar més tard.",
  too_many_pending_requests: "Massa intents. Torna-ho a provar més tard.",
  too_many_codes: "Ja t'hem enviat 3 codis en l'última hora. Espera una mica i torna'l a demanar.",
  whatsapp_send_failed: "No t'hem pogut enviar el WhatsApp. Revisa el número i torna-ho a provar.",
  invalid_code: "Codi incorrecte.",
  code_expired: "El codi ha caducat. Demana'n un de nou.",
  too_many_attempts: "Massa intents. Torna a començar el registre.",
  signup_not_found: "No hem trobat el registre. Torna a començar.",
  signup_not_pending: "Aquest registre ja no és vàlid. Torna a començar.",
  invalid_lead_token: "L'enllaç ha caducat. Crea el teu compte amb el formulari.",
};
export const ERROR_GENERICO = { es: "Algo salió mal. Inténtalo de nuevo.", ca: "Alguna cosa ha fallat. Torna-ho a provar." };
